import { ModulesMap, ModulesConfigMap } from '../data/modulesMaps'

export default {
	getDoneWorks: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORKS,
	},
	getDoneWorkPreview: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK_PREVIEW,
	},
	getDoneWorkPopup: {
		apiServiceMethodName:
			ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK_POPUP,
	},
	createDoneWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS].CREATE_DONE_WORK,
	},
	getDoneWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS].GET_DONE_WORK,
	},
	patchDoneWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS].PATCH_DONE_WORK,
	},
	putDoneWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS].PUT_DONE_WORK,
	},
	deleteDoneWork: {
		apiServiceMethodName: ModulesConfigMap[ModulesMap.DONE_WORKS].DELETE_DONE_WORK,
	},
}